import { BasketballIncidentId } from '@collector/sportsapi-client-legacy'

import { IncidentsTeamPossessionConfig } from '../../configuration'

export const incidentsTeamPossessionConfig: IncidentsTeamPossessionConfig<BasketballIncidentId> =
  {
    resetPossessionIncidents: new Set([
      BasketballIncidentId.Foul,
      BasketballIncidentId.Turnover,
      BasketballIncidentId.DefensiveRebound,
      BasketballIncidentId.FourPointShotMade,
      BasketballIncidentId.ThreePointShotMade,
      BasketballIncidentId.TwoPointShotMade,
      BasketballIncidentId.FreeThrowIn,
      BasketballIncidentId.Steal,

      BasketballIncidentId.BreakAfterFirstHalf,

      BasketballIncidentId.BreakAfterFirstQuarter,
      BasketballIncidentId.BreakAfterSecondQuarter,
      BasketballIncidentId.BreakAfterThirdQuarter,

      BasketballIncidentId.WaitingForOvertime,
      BasketballIncidentId.BreakAfterFirstOvertime,
      BasketballIncidentId.BreakAfterSecondOvertime,
      BasketballIncidentId.BreakAfterThirdOvertime,
      BasketballIncidentId.BreakAfterFourthOvertime,

      BasketballIncidentId.FinishedRegularTime,
      BasketballIncidentId.FinishedAfterOvertime,
      BasketballIncidentId.FinishedAwardedWin,
      BasketballIncidentId.ToFinish,
      BasketballIncidentId.Cancelled,
      BasketballIncidentId.Postponed,
      BasketballIncidentId.StartDelayed,
      BasketballIncidentId.Abandoned,
      BasketballIncidentId.Interrupted,
      BasketballIncidentId.NotStarted,

      BasketballIncidentId.TvTimeout,
      BasketballIncidentId.Timeout,
      BasketballIncidentId.PlayUnderReview,
      BasketballIncidentId.RefereeInjury,
      BasketballIncidentId.BreakDuringTheGame,
    ]),
  }
